import { render, staticRenderFns } from "./EventsBestPlayedWidget.vue?vue&type=template&id=134c5ffd"
import script from "./EventsBestPlayedWidget.vue?vue&type=script&lang=js"
export * from "./EventsBestPlayedWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports